import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

const handleDragStart = (e) => e.preventDefault();

export default function Slider({ campaignImages }) {
  const images = [...campaignImages, ...campaignImages].map((image, i) => (
    <img
      alt="campaign-img"
      key={i}
      onDragStart={handleDragStart}
      role="presentation"
      src={`https://chabadoncampus.com/cdn-cgi/image/fit=scale-down,width=640/${image.url}`}
      // transforming image width to 640px (vs using the display width of 287px, as recommended by Cloudflare) for better image clarity
      style={{
        height: "224px",
        width: "287px",
        objectFit: "cover",
      }}
    />
  ));

  return (
    <AliceCarousel
      animationDuration={1000}
      autoHeight
      autoPlay
      autoPlayInterval={2000}
      autoPlayStrategy="none"
      autoWidth
      disableButtonsControls={true}
      disableDotsControls={true}
      infinite={true}
      items={images}
    />
  );
}
